import React, { Component } from 'react'
import { message, Button } from 'antd';
import "./arrow.css";
function Arrow({action, hasMore}) {
    return (
        <span type="button" onClick={hasMore ? action : () => {}} style={{
            fontSize: '14px',
            color: '#818181',
            display: 'inline-block',
            cursor: 'pointer',
            letterSpacing: 0}}
        >
            {
                hasMore ?
                <span>more items <svg viewBox="64 64 896 896" data-icon="down" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"></path></svg></span>
                :
                <p>No more</p>
            }
        </span>
        
    )
}

export function Heart({action, color = "#FFFFFF", size = "14px"}) {
    const info = () => {
        message.success('Successfully saved');
    };
    let wrapperFn;
    if (action) {
        wrapperFn = () => {
            action();
            info();
        }
    } else {
        wrapperFn = () => {}
    }
    return (
        <span type="button" onClick={wrapperFn} style={{
            fontSize: size,
            color: color,
            display: 'inline-block',
            cursor: 'pointer',
            letterSpacing: 0}}
        >
            <svg viewBox="64 64 896 896" data-icon="heart" width="1em" height="1em" fill="transparent" aria-hidden="true"><path fill={color} d="M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z"></path></svg>
        </span>
    )
}

export default Arrow;

// <path fill="#fff0f6" d="M679.7 201c-73.1 0-136.5 40.8-167.7 100.4C480.8 241.8 417.4 201 344.3 201c-104 0-188.3 82.6-188.3 184.5 0 201.2 356 429.3 356 429.3s356-228.1 356-429.3C868 283.6 783.7 201 679.7 201z"></path>


// WEBPACK FOOTER //
// ./src/features/commonUI/arrow.js